import React from 'react';

export default function ScannerModeTabs({ scannerMode, onSelectCamera, onSelectManual }) {
  const base = 'flex-1 py-3 text-sm font-medium';
  const active = 'bg-blue-50 text-blue-600 border-b-2 border-blue-600';
  const inactive = 'text-gray-500 hover:text-gray-700';
  return (
    <div className="flex border-b border-gray-200">
      <button
        onClick={onSelectCamera}
        className={`${base} ${scannerMode === 'camera' ? active : inactive}`}
        data-testid="scanner-tab-camera"
      >
        📷 Camera
      </button>
      <button
        onClick={onSelectManual}
        className={`${base} ${scannerMode === 'manual' ? active : inactive}`}
        data-testid="scanner-tab-manual"
      >
        ⌨️ Manual
      </button>
    </div>
  );
}
